<template>
    <div class="page-cabinet__back-forward" v-if="hasPrevButton || hasNextButton">
        <ui-button
            v-bind:icon-left="'arrow-left'"
            v-on:click="() => $emit('on-back')"
            theme="secondary-1"
            :isWidthFree="true"
            :style="{ visibility: !hasPrevButton ? 'hidden' : 'visible' }"
        >
            Назад
        </ui-button>
        <ui-button
            v-bind:icon-right="'arrow-right'"
            v-on:click="() => $emit('on-forward')"
            theme="secondary-1"
            :isWidthFree="true"
            :style="{ visibility: !hasNextButton ? 'hidden' : 'visible' }"
        >
            Вперед
        </ui-button>
    </div>
</template>

<script>
export default {
    name: 'page-cabinet-back-forward',
    props: {
        hasPrevButton: {
            type: Boolean,
            default: false,
        },
        hasNextButton: {
            type: Boolean,
            default: false,
        },
    },
};
</script>

<style scoped lang="less">
@import '~theme';

.page-cabinet__back-forward {
    .typography-body();

    display: flex;
    flex-direction: row;
    gap: 8px;
    justify-content: space-between;

    &-item {
        flex-shrink: 0;
        text-decoration: underline;
        color: @color-gray-main;
        cursor: pointer;
        &._active {
            color: @color-primary;
        }
    }
}

</style>
